import {defineMessages} from 'react-intl';

const messages = defineMessages({
  resetYourPassword: {
    id: 'resetYourPassword',
    defaultMessage: 'Reset your password'
  },
  setYourPassword: {
    id: 'setYourPassword',
    defaultMessage: 'Set your password'
  },
  enterYourEmail: {
    id: 'enterYourEmail',
    defaultMessage: 'Enter your account email address and we will send you a password reset link.'
  },
  enterYourPhoneNumber: {
    id: 'enterYourPhoneNumber',
    defaultMessage: 'Enter your phone number and we will send you a reset code.'
  },
  sendResetLink: {
    id: 'sendResetLink',
    defaultMessage: 'Send password reset link'
  },
  sendResetCode: {
    id: 'sendResetCode',
    defaultMessage: 'Send reset code'
  },
  returnToSignIn: {
    id: 'returnToSignIn',
    defaultMessage: 'Return to sign in'
  },
  email: {
    id: 'common.forms.email',
    defaultMessage: 'Email'
  },
  newPassword: {
    id: 'ResetPassword.newPassword',
    defaultMessage: 'New password'
  },
  confirmNewPassword: {
    id: 'confirmNewPassword',
    defaultMessage: 'Confirm new password'
  },
  title: {
    id: 'ResetPassword.title',
    defaultMessage: 'Reset Password'
  },
  setPassword: {
    id: 'ResetPassword.setPassword',
    defaultMessage: 'Set Password'
  },
  sentPasswordResetLink: {
    id: 'sentPasswordResetLink',
    defaultMessage: 'Password reset link sent. Follow the instructions in the email.'
  },
  passwordsDoNotMatch: {
    id: 'passwordsDoNotMatch',
    defaultMessage: 'Passwords do not match'
  },
  resetLinkExpired: {
    id: 'resetLinkExpired_contactAdmin',
    defaultMessage: 'Your password reset link expired. Please contact your platform admin to resend the invitation.'
  },
  setLinkExpired: {
    id: 'setLinkExpired_contactAdmin',
    defaultMessage: 'Your password set link expired. Please contact your platform admin to resend the invitation.'
  },
  requestNewResetLink: {
    id: 'requestNewResetLink',
    defaultMessage: 'Request a new password reset link'
  },
  canNotSentPasswordResetLink: {
    id: 'canNotSentPasswordResetLink',
    defaultMessage: "Couldn't send password reset link"
  },
  canNotResetPassword: {
    id: 'canNotResetPassword',
    defaultMessage: "Password couldn't be reset"
  },
  passwordReset: {
    id: 'passwordReset',
    defaultMessage: 'Password reset'
  },
  invalidEmail: {
    id: 'invalidEmail',
    defaultMessage: 'Invalid email address.'
  },
  invalidPhoneNumber: {
    id: 'invalidPhoneNumber',
    defaultMessage: 'Invalid phone number.'
  },
  meetAllRequirements: {
    id: 'meetAllRequirements',
    defaultMessage: 'Your new password should meet all requirements.'
  },
  phoneNumber: {
    id: 'phoneNumber',
    defaultMessage: 'Phone Number'
  },
  resetCode: {
    id: 'resetCode',
    defaultMessage: 'Reset Code'
  },
  invalidResetCode: {
    id: 'invalidResetCode',
    defaultMessage: 'Invalid reset code'
  }
});
export default messages;
